export { FloatingImage } from './FloatingImage';
